import { ModelDeploymentRequest, BacktestRequest } from '@/types/requests';
import axios from 'axios';
import axiosRetry from "axios-retry";

axios.defaults.timeout = 600000;

export function createDeploymentAPIClient(token: string) {
  const instance = axios.create({
    baseURL: process.env.NODE_ENV === "production" ? 'https://deploy.blankly.finance' : "https://deployment-api-ictyw5jxjq-uc.a.run.app",
    headers: {
      token: token,
    },
  });

  axiosRetry(instance, { retryDelay: axiosRetry.exponentialDelay });

  instance.interceptors.response.use((value) => {
    return value.data;
  });
  return instance;
}

export const listKeys = async (token: string, projectId: string) => {
  const req = createDeploymentAPIClient(token);
  return req.post('/project/list-tokens', { projectId });
}

export function deleteKey(token: string, projectId: string, tokenId: string) {
  const req = createDeploymentAPIClient(token);
  return req.post('/project/delete-project-token', { projectId, tokenId });
}

export function generateKey(token: string, projectId: string, name: string) {
  const req = createDeploymentAPIClient(token);
  return req.post('/project/generate-project-token', { projectId, name, autogenerated: false });
}

export function deployModel(token: string, deployment: ModelDeploymentRequest) {
  const req = createDeploymentAPIClient(token);
  return req.get('/model/run', { data: deployment });
}

export function backtest(token: string, backtestData: BacktestRequest) {
  const req = createDeploymentAPIClient(token);
  return req.get('/model/backtest', { data: backtestData });
}